import React from "react";

const MonthlyLongTermRentals = () => {
  return (
    <>
      {/* ===== BREADCRUMB ===== */}
      <section
        className="breadcrumb-section"
        style={{
          backgroundImage:
            "url(/images/background/inner-banner-bg.jpg)",
        }}
      >
        <div className="container">
          <div className="banner-content text-center">
            <h1>Monthly & Long-Term Car Rentals</h1>
          </div>
        </div>
      </section>

      {/* ===== MAIN CONTENT SECTION ===== */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">
            
            {/* IMAGE */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src="/images/gallery/04.jpeg"
                alt="Monthly Corporate Car Rental Services"
                className="img-fluid rounded shadow-lg"
              />
            </div>

            {/* CONTENT */}
            <div className="col-lg-6">
              <h2 className="mb-3">
                <span className="text-danger">Monthly</span> & Long-Term Rental Solutions
              </h2>

              <p>
                Pune Corporate Cars India Pvt. Ltd. provides structured and
                reliable monthly and long-term car rental solutions for
                corporate organizations requiring dedicated mobility support
                over extended periods. These solutions are ideal for employee
                transportation, executive travel, and ongoing business
                operations.
              </p>

              <p>
                Our long-term rental programs are designed to reduce
                administrative effort while ensuring predictable costs,
                consistent service quality, and uninterrupted vehicle
                availability throughout the contract duration.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* ===== SPECIFICATIONS ===== */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="mb-3">Service Specifications</h2>
              <p className="text-muted">
                Clearly defined inclusions for corporate monthly rental contracts.
              </p>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-8">
              <ul className="list-unstyled text-start">
                <li className="mb-3">
                  ✔ <strong>Fixed monthly billing</strong> with pre-agreed package rates.
                </li>
                <li className="mb-3">
                  ✔ <strong>Chauffeur included</strong> as part of the corporate rental contract.
                </li>
                <li className="mb-3">
                  ✔ <strong>Round-the-clock availability</strong> for all scheduled journeys.
                </li>
                <li className="mb-3">
                  ✔ <strong>Fleet maintenance and technical support</strong> included in the contract.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHY CHOOSE US ===== */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="mb-3">Why Choose Our Long-Term Rentals?</h2>
              <p className="text-muted">
                A dependable corporate mobility solution built for consistency and scale.
              </p>
            </div>
          </div>

          <div className="row">

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Custom rental plans aligned with business needs</li>
                <li className="mb-3">✔ No vehicle ownership or maintenance burden</li>
                <li className="mb-3">✔ Professional driver & operations management</li>
                <li className="mb-3">✔ Dedicated relationship manager</li>
              </ul>
            </div>

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Scalable for growing teams</li>
                <li className="mb-3">✔ Nationwide service capability</li>
                <li className="mb-3">✔ Transparent SLAs & compliance reporting</li>
                <li className="mb-3">✔ Improved employee & executive travel experience</li>
              </ul>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default MonthlyLongTermRentals;
